<template>
  <div class="empty" v-if="show">
    <img v-if="img" class="empty-cart" :src="img" :style="imgstyle" />
    <div v-if="title" class="title" :style="titlestyle">{{ title }}</div>
    <div v-if="subTitle" class="sub-title">{{ subTitle }}</div>
    <van-button
      color="linear-gradient( 170deg, #FFB695 0%, #FD7F5C 100%)"
      style="border:0;"
      v-if="btnTxt && !otherBtnTxt"
      custom-class="btn"
      @click="goTo"
      block
      >{{ btnTxt }}</van-button
    >
    <div v-if="otherBtnTxt" class="btnTwo">
      <van-button
        color="#fff"
        style="border:1px solid #222;color:#222;width: 132px;"
        custom-class="btn"
        type="primary"
        @click="goTo"
        block
        >{{ btnTxt }}</van-button>

      <van-button
        color="linear-gradient( 170deg, #FFB695 0%, #FD7F5C 100%)"
        style="width: 132px;border:0;"
        custom-class="btn"
        @click="seedetail"
        block
        >{{ otherBtnTxt }}</van-button
      >
    </div>
  </div>
</template>
<script>
import { Button } from 'vant'

export default {
  components: {
    [Button.name]: Button
  },
  props: {
    img: String,
    title: String,
    subTitle: String,
    btnTxt: String,
    show: Boolean,
    imgstyle: String,
    titlestyle: String,
    otherBtnTxt: String
  },
  emits: ['go', 'seedetail'],
  setup(props, { emit }) {
    function goTo() {
      emit('go')
    }
    function seedetail() {
      emit('seedetail')
    }
    return {
      goTo,
      seedetail
    }
  }
}
</script>
<style lang="less" scoped>
.btnTwo {
  width: 273px;
  display: flex;
  margin: 0 auto;
  justify-content: space-between;
  > div {
    width: 132px;
    &:nth-child(1) {
      margin-right: 9px;
    }
  }
}
.empty {
  width: 82%;
  margin: 0 auto;
  text-align: center;
  padding-top: 72px;

  .empty-cart {
    width: 60px;
    height: 60px;
    margin: 0 auto 8px;
  }

  .van-icon-smile-o {
    font-size: 50px;
  }

  .title {
    font-size: 17px;
    font-weight: bold;
    text-align: center;
    color: #222;
    line-height: 24px;
    margin-bottom: 8px;
  }

  .sub-title {
    font-size: 14px;
    text-align: center;
    color: #222;
    line-height: 20px;
  }

  .van-button {
    margin-top: 72px;
    margin-bottom: 20px;
    font-weight: bold;
    font-size: 16px;
  }
}
</style>
